import request from "@/api/gassApi/service";
import { type AxiosRequestConfig } from "axios";
import { type DeepRequired } from "../../interface";

export interface PostV1ChatloginChatLoginResult {
    code: number;
    data: string;
    message: string;
}

/**
 * 吉聊 登陆
 * /v1/chatlogin/chatLogin
 */
export function postV1ChatloginChatLogin(input?: PostV1ChatloginChatLoginInput, config?: AxiosRequestConfig) {
    return request.post<DeepRequired<PostV1ChatloginChatLoginResult>>(`/v1/chatlogin/chatLogin`, input, config);
}

export interface PostV1ChatloginChatLoginInput {
    user_name: string;
    pwd: string;
}
